"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var firestore_1 = require("firebase/firestore");
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var FileListItem_1 = __importDefault(require("atomicComponents/atoms/FileUpload/FileListItem"));
var SuccessMessage_1 = __importDefault(require("atomicComponents/molecules/Alerts/SuccessMessage"));
var FieldDropzone_1 = __importDefault(require("components/Form/FieldDropzone"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var storage_1 = require("utils/firebase/storage");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var DropzoneInvoices = function (_a) {
    var _b;
    var service = _a.service, insightRequest = _a.insightRequest;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _c = __read(react_1.default.useState(false), 2), visibility = _c[0], handleVisibility = _c[1];
    var _d = __read((0, hooks_1.useSubmitter)('insight_requests', insightRequest === null || insightRequest === void 0 ? void 0 : insightRequest.id, {
        serviceId: service.id,
        companyId: profile.companyId,
    }), 2), submitInsightRequest = _d[0], isSubmitting = _d[1];
    var track = (0, analytics_1.useTracker)();
    var onSubmit = function (_a) {
        var uploadedDocsFiles = _a.uploadedDocsFiles, fileNotes = _a.fileNotes;
        return __awaiter(void 0, void 0, void 0, function () {
            var uploadTimestamp, uploadedDocsArr;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(uploadedDocsFiles === null || uploadedDocsFiles === void 0 ? void 0 : uploadedDocsFiles.length) && !fileNotes) {
                            return [2 /*return*/, null];
                        }
                        if (!(uploadedDocsFiles === null || uploadedDocsFiles === void 0 ? void 0 : uploadedDocsFiles.length)) {
                            return [2 /*return*/, submitInsightRequest({ fileNotes: fileNotes })];
                        }
                        uploadTimestamp = Math.round(Date.now() / 1000);
                        return [4 /*yield*/, Promise.all(uploadedDocsFiles.map(function (f, idx) { return __awaiter(void 0, void 0, void 0, function () {
                                var id, storagePath, url;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            id = "".concat(uploadTimestamp, "_").concat(idx);
                                            storagePath = "docs/".concat(profile.id, "/").concat(id, "-").concat(f.name);
                                            return [4 /*yield*/, (0, storage_1.uploadFileAndGetUrl)(storagePath, f)];
                                        case 1:
                                            url = _a.sent();
                                            return [2 /*return*/, __assign({ id: id, storagePath: storagePath, url: url }, (0, pick_1.default)(f, ['size', 'name', 'type']))];
                                    }
                                });
                            }); }))];
                    case 1:
                        uploadedDocsArr = _c.sent();
                        track('Quote Submitted', {
                            fileNotes: fileNotes,
                            serviceId: service.id,
                            serviceName: service.name,
                            filesUploaded: uploadedDocsArr.map(function (d) { return ({ name: d.name, url: d.url }); }),
                        });
                        return [2 /*return*/, submitInsightRequest({
                                fileNotes: fileNotes,
                                uploadingUserIds: (0, firestore_1.arrayUnion)(profile.id),
                                uploadByUserMap: (_b = {}, _b[uploadTimestamp] = profile.id, _b),
                                uploadedDocIds: firestore_1.arrayUnion.apply(void 0, __spreadArray([], __read(uploadedDocsArr.map(function (d) { return d.id; })), false)),
                                uploadedDocs: Object.fromEntries(uploadedDocsArr.map(function (_a) {
                                    var id = _a.id, doc = __rest(_a, ["id"]);
                                    return [id, doc];
                                })),
                            })];
                }
            });
        });
    };
    if ((_b = insightRequest === null || insightRequest === void 0 ? void 0 : insightRequest.uploadedDocIds) === null || _b === void 0 ? void 0 : _b.length) {
        var uploadedDocs = insightRequest.uploadedDocIds.map(function (uDId) { return (__assign({ id: uDId }, insightRequest.uploadedDocs[uDId])); });
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SuccessMessage_1.default, { message: "Thanks for uploading your quote/invoice. We\u2019ll be in touch by email shortly." }), uploadedDocs.map(function (uD) {
                    var onRemove = function () {
                        var _a;
                        return submitInsightRequest({
                            uploadedDocIds: (0, firestore_1.arrayRemove)(uD.id),
                            uploadedDocs: (_a = {}, _a[uD.id] = __assign(__assign({}, uD), { isDeleted: true }), _a),
                        });
                    };
                    return (0, jsx_runtime_1.jsx)(FileListItem_1.default, { fileName: uD.name, onRemove: !isSubmitting ? onRemove : undefined }, uD.id);
                })] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Got a quote for ", service.name, "?"] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mt: 1 }, { children: "Upload it here \uD83D\uDC47 to get a second opinion." })), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldDropzone_1.default, { name: "uploadedDocsFiles", maxFiles: 3, handleVisibility: handleVisibility }), visibility && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "fileNotes", color: "secondary", label: "Add notes here", component: TextField_1.default, multiline: true, rows: 2 }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleSubmit, sx: { ml: 'auto' }, type: "submit", isSending: submitting }, { children: submitting ? 'Uploading...' : 'Submit' }))] }))] }));
                } }))] }));
};
exports.default = DropzoneInvoices;
